import React, { useState } from "react"
import { Button } from "reactstrap"
import InfoModal, { getInfoContent } from "./InfoModal"

const InfoButton = ({
  type,
  title,
  size = "sm",
  className = "",
  style = {}
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => setModalOpen(!modalOpen)

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    toggleModal()
  }

  return (
    <>
      <Button
        color="info"
        size={size}
        outline
        className={`info-button ${className}`}
        style={{
          borderRadius: '50%',
          width: size === 'sm' ? '24px' : '32px',
          height: size === 'sm' ? '24px' : '32px',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #17a2b8',
          backgroundColor: 'transparent',
          ...style
        }}
        onClick={handleClick}
        title="Click to see how this data is calculated"
      >
        <i
          className="bx bx-info-circle"
          style={{
            fontSize: size === 'sm' ? '12px' : '14px',
            color: '#17a2b8'
          }}
        ></i>
      </Button>

      <InfoModal
        isOpen={modalOpen}
        toggle={toggleModal}
        title={title || 'Data Calculation Information'}
        content={getInfoContent(type)}
      />
    </>
  )
}

export default InfoButton
